/*
 * File: ui-label.ts
 * File Created: 2023-12-18 11:45:26
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2024-11-18 05:26:47
 * Modified By: Val Liu
 * -----
 */

import { ObjectHelper } from "@root/core/utilities";
import {
    BaseUITag,
    EUITagRuleType,
    EUITagTarget,
    IUITagInput,
    IUITagResult,
    IUITagMoreTagsUnit,
    UITag,
    IUIRelationPair,
    EUITagRuleUnion,
} from "../core";

// @uiProvideRow - converts this field as same as the full row.

@UITag.set()
export class uiProvideRow extends BaseUITag {
    appliedTo: EUITagTarget[] = [
        EUITagTarget.FormElement,
        EUITagTarget.FormSubmit,
        EUITagTarget.TableBodyCell,
    ];
    ruleTypes: EUITagRuleUnion[] = [EUITagRuleType.Boolean];
    allowNullRule: boolean = true;

    parse(input: IUITagInput): IUITagResult | null {
        let rule = this.parseRule(input) ?? true;
        if (rule == false) return null;

        let moreTags: IUITagMoreTagsUnit[] = [];
        moreTags.push(
            {
                tag: "uiConverter",
                rule: (o) => {
                    return o.row
                        ? { ...ObjectHelper.deepClone(o.row), [o.name]: null }
                        : null;
                },
            },
            {
                tag: "uiSubmitIgnore",
                rule: true,
            },
        );
        return {
            specials: {
                moreTags,
            },
        };
    }
}
